import { render, staticRenderFns } from "./CouponChoose.vue?vue&type=template&id=cc987dbe&scoped=true&"
import script from "./CouponChoose.vue?vue&type=script&lang=js&"
export * from "./CouponChoose.vue?vue&type=script&lang=js&"
import style0 from "./CouponChoose.vue?vue&type=style&index=0&id=cc987dbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc987dbe",
  null
  
)

export default component.exports